import { decrypt, encrypt } from "./crypto";
import { decryptMessage, encryptMessage } from "./crypto_service";


export const encryptedData = (payload) => {
    return process.env.REACT_APP_ENCRYPTION_TYPE === "RSA" ? encryptMessage(payload): encrypt(payload)
};

export const decryptData = (payload) => {
    return process.env.REACT_APP_ENCRYPTION_TYPE === "RSA" ? decryptMessage(payload): decrypt(payload)
};
